<template>
  <div ref="galList" class="mob-gal-lst-wrp" :style="{
        'height':isOpen ? `${listHeight}px` : '350px',
        'transition': 'height 1.25s ease-out'
      }">
      <a 
        class="mob-gal-lst-sing"
        v-for="(url,index) in urls"
        :key="index"
        :href="url.link"
        target="_blank"
      >
          <div class="mob-gal-lst-img">
              <img v-image-load:fade :src="url.list" :alt="url.name">
          </div>

          <div class="mob-gal-lst-info-wrp">
            <p class="mob-gal-lst-name">{{url.name}}</p>
            <p class="mob-gal-lst-category">{{url.category}}</p>
            <div @click.prevent="isOpen = true" class="mob-gal-lst-trigger">
                <img  v-if="index == 1 && !isOpen && urls[2]" src="../../assets/img/arrow-down.svg" alt="">
            </div>
          </div>
      </a>
      
  </div>
</template>

<script>
export default {
    props:{
        urls:Array
    },

    data(){
        return{
            isOpen:false
        }
    },

    computed:{
        listHeight(){
            return this.$refs.galList.scrollHeight
        }
    }
}
</script>

<style>
.mob-gal-lst-wrp{
    margin-top: 34px;
    overflow: hidden;
}

.mob-gal-lst-sing{
    position: relative;
    display: block;
    margin-bottom: 13px;
    overflow: hidden;
    border-radius: 5px;
}

.mob-gal-lst-img{
    height: 170px;
    overflow: hidden;
    background: transparent linear-gradient(0deg, #000000F7 0%, #5454544D 100%) 0% 0% no-repeat padding-box;
    opacity: 0.63;
}

.mob-gal-lst-img img{
    height: 100%;
    width: 100%;
    object-fit: cover;
}

.mob-gal-lst-info-wrp{
    position: absolute;
    color: white;
    height: 100%;
    width: 100%;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.mob-gal-lst-name{
    font-size: 24px;
    line-height: 40px;
    font-weight: 500;
}

.mob-gal-lst-category{
    font-size: 15px;
    line-height: 20px;
    font-weight: 300;
}

.mob-gal-lst-trigger{
    position: absolute;
    bottom: 20px;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    cursor: pointer;
}
</style>